<template>
  <div class="table-container">
    <table
      class="table is-striped is-hoverable is-fullwidth table-container"
      id="timber-table"
    >
      <thead>
        <td>Pos.</td>
        <td>Stamm-Nr.</td>
        <td>Baumart</td>
        <td>Länge l in m</td>
        <td id="headerDiameter">&Oslash; d in cm</td>
        <td v-if="measuredWithBark">d ohne Rinde</td>
        <td>Stärkekl.</td>
        <td>Güte</td>
        <td>
          <span
            style="border-bottom: 1px dotted black; cursor: help;"
            data-balloon-length="large"
            aria-label="Berechnet nach der Huberschen Formel:                            V = π / 4 × d² × L × 10⁻⁴"
            data-balloon-pos="right"
            >Volumen in fm</span
          >
        </td>
        <td>Bemerkung</td>
        <td></td>
        <td></td>
      </thead>
      <tbody>
        <timber-table-row
          v-for="(row, index) in rows"
          v-bind:key="row.id"
          v-bind:row="row"
          v-bind:index="index"
          v-on:add-row="addRow"
          v-on:remove-row="removeRow"
          v-bind:measuredWithBark="measuredWithBark"
        />
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3">
            <button
              class="button is-small"
              type="button"
              v-on:click="$emit('remove-all-rows')"
            >
              Tabelle zurücksetzen
            </button>
          </td>

          <td></td>
          <td></td>
          <td></td>
          <td v-if="measuredWithBark"></td>
          <td class="has-text-right">Summe:</td>
          <td class="input-volume-total">{{ totalVolume }}</td>
          <!-- here the sum of the volumes-->
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import TimberTableRow from "./TimberTableRow.vue";

export default {
  name: "timber-table",
  components: {
    TimberTableRow
  },
  props: {
    rows: Array,
    measuredWithBark: Boolean,
    totalVolume: String
  },
  methods: {
    addRow: function(index) {
      this.rows.splice(index + 1, 0, {
        id: this.rows.length + 1, // the index+1 of the next free position in array
        logNumber: this.calculateNextLogNumber(index), // calculated
        woodType: "Fichte",
        length: this.getLengthOfLastRow(index),
        diameter: Number,
        diameterWithoutBark: 0,
        strengthClass: "", // calculated
        quality: "B",
        volume: 0,
        note: ""
      });

      // correct the id property of the rows
      this.rows.forEach(function(x, i, a) {
        x.id = a.indexOf(x) + 1;
      }, this);
    },
    calculateNextLogNumber: function(index) {
      let lastLogId = this.rows[index].logNumber;
      if (!new RegExp(/\d/gm).test(lastLogId)) {
        return "";
      }

      let num = parseInt(lastLogId.match(/\d+$/));
      let pos = lastLogId.indexOf(num);
      let str = lastLogId.slice(0, pos);
      num++;

      let containsJustZeros = true;
      str.split('').forEach(function(char) {
        if (char !== "0") {
          containsJustZeros = false;
        }
      })

      if (containsJustZeros && num === 10) {
      // remove one zero if the pos number equals 10
        return str.substring(0, str.length - 1) + num;
      // remove two zeros if the pos number equals 100

      } else if(containsJustZeros && num === 100) {
        return str.substring(0, str.length - 2) + num;
      } else {
        return str + num;
      }
    },
    getLengthOfLastRow: function(index) {
      return this.rows[index].length;
    },
    removeRow: function(index) {
      this.rows.splice(index, 1);
      if (this.rows.length === 0) {
        this.addRow();
      }
    }
  }
};
</script>

<style scoped>
</style>